import dateFormatType from './dateFormatType';
import { capitalizeFirstLetter } from './common';
import momentLocalTimezone from './momentLocalTimezone';

const selectFormatDate = (date, format = dateFormatType.DAY) => {
  switch (format) {
    case dateFormatType.DAY:
      return momentLocalTimezone(date).format('DD-MMM-YY');
    case dateFormatType.MONTH_AND_YEAR:
      return momentLocalTimezone(date).format('MMM - YY');
    case dateFormatType.MONTH:
      return capitalizeFirstLetter(momentLocalTimezone(date).format('MMM-YY'));
    case dateFormatType.QUARTER:
      return `${capitalizeFirstLetter(
        momentLocalTimezone(date)
          .startOf('quarter')
          .format('MMM-YY')
      )} - ${capitalizeFirstLetter(
        momentLocalTimezone(date)
          .endOf('quarter')
          .format('MMM-YY')
      )}`;
    case dateFormatType.YEAR:
      return momentLocalTimezone(date).format('YYYY');
    case dateFormatType.ONLY_DAY:
      return momentLocalTimezone(date).format('DD');
    case dateFormatType.ONLY_MONTH:
      return capitalizeFirstLetter(momentLocalTimezone(date).format('MMM'));
    case dateFormatType.DATE_COMPLETE:
      return momentLocalTimezone(date).format('DD-MMM-YY HH:mm:ss');
    default:
      return momentLocalTimezone(date).format('DD-MMM-YY');
  }
};

export default selectFormatDate;
